<div
  aria-labelledby="user-menu-button"
  aria-orientation="vertical"
  class="rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
  role="menu" tabindex="-1">

  <div class="flex items-center gap-x-3 px-3 py-2 border-b border-gray-100">
    <span class="inline-flex size-8 shrink-0 items-center justify-center rounded-full bg-indigo-600">
      <span class="text-xs font-medium text-white">{{ initials }}</span>
    </span>
    <div class="min-w-0">
      <p class="truncate text-sm font-semibold text-gray-900">{{ currentUser?.fullName || currentUser?.userName }}</p>
      <p class="truncate text-xs text-gray-500">{{ currentUser?.email }}</p>
    </div>
  </div>

  <a [href]="profileUrl" target="_blank"
     class="block px-3 py-1.5 text-sm/6 text-gray-900 hover:bg-gray-50 hover:outline-none"
     id="user-menu-item-0" role="menuitem" tabindex="-1">
    Mon profil
  </a>

  <button (click)="logout()"
          class="block w-full text-left px-3 py-1.5 text-sm/6 text-gray-900 hover:bg-gray-50 hover:outline-none"
          id="user-menu-item-1" role="menuitem" tabindex="-1">
    Se déconnecter
  </button>

</div>
